var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDianjiedian(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    clipPath: "url(#clip0_31_1890)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 605",
    d: "M1.75 13L8.75 5L15.75 13",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 66",
    cx: 8.75,
    cy: 6,
    r: 1.5,
    fill: "#F8F8F8",
    stroke: "#2F88FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_1890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDianjiedian);
export default __webpack_public_path__ + "static/media/dianjiedian.54c5709d00a0f1d6d87b69691d02d0df.svg";
export { ForwardRef as ReactComponent };